import { render, staticRenderFns } from "./AddTokenCard.vue?vue&type=template&id=e47f521c&"
import script from "./AddTokenCard.vue?vue&type=script&lang=js&"
export * from "./AddTokenCard.vue?vue&type=script&lang=js&"
import style0 from "./AddTokenCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports